import MunicipalitySummaryApiClient from "api/MunicipalitySummaryApiClient";
import { useBuildReport } from "hooks/reports/useBuildReport";
import { ReportFormat } from "api/Enums";

export function useGenerateMunicipalitySummary(options) {
    return useBuildReport(
        (municipalityId) =>
            MunicipalitySummaryApiClient.buildMunicipalitySummary(
                municipalityId,
                ReportFormat.Json,
            ),
        options,
    );
}
